import React from 'react';
import { Control, UseFormSetValue, UseFormWatch, FieldErrors } from 'react-hook-form';
import { NewSalaryEntryFieldset, SalaryHistoryFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface RemunerationTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const RemunerationTab: React.FC<RemunerationTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="space-y-6">
            <NewSalaryEntryFieldset
                context={context}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
                collaboratorId={collaboratorId}
            />

            <SalaryHistoryFieldset
                context={context}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
                collaboratorId={collaboratorId}
            />
        </div>
    );
};

export default RemunerationTab;
